
export enum PropertyPackage {
  PengRobinson = 0,
}


export enum Flip {
  None = 0,
  X = 1,
  Y = 2
}

export enum NozzleDirection {
  Inlet = 0,
  Outlet = 1
}

export enum Origin {
  Start = 0,
  Center = 1,
  End = 2
}

export enum EquipmentType {
  BatteryLimit = 0,
  Stream = 1,
  EnergyStream = 2,
  Vessel = 3,
  StreamMixer = 4,
  StreamSplitter = 5,
  Pump = 6,
  Compressor = 7,
  Reactor = 8,
  Expander = 9,
  Spreadsheet = 10,
  ComponentSplitter = 11,
  HeatExchanger = 12,
  Set = 13,
  Deaerator = 111,
  SteamDrum = 102,
  Burner = 110
}

export enum AutoLayout {
  Left = 1,
  Top = 2,
  Right = 3,
  Bottom = 4
}
